import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

/*
|--------------------------------------------------------------------------
| LIST LECTURES
|--------------------------------------------------------------------------
*/

export async function getLecturesApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 10);
    fd.append("search", payload.search || "");
    fd.append("course_id", payload.course_id || "");
    fd.append("module_id", payload.module_id || "");
    fd.append("category_id", payload.category_id || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/lectures/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Lectures Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Lectures fetch failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| LECTURE STATS
|--------------------------------------------------------------------------
*/

export async function getLectureStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/lectures/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Lecture Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Lecture stats fetch failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| VIEW LECTURE
|--------------------------------------------------------------------------
*/

export async function getLectureApi(lectureId) {
  try {
    const fd = new FormData();

    fd.append(
      "lession_id",
      lectureId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/lectures/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Lecture Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Lecture fetch failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| CREATE LECTURE
|--------------------------------------------------------------------------
*/

export async function createLectureApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append(
      "lession_module",
      payload.lession_module || ""
    );

    fd.append(
      "lession_parent",
      payload.lession_parent || ""
    );

    fd.append(
      "lession_title",
      payload.lession_title || ""
    );

    fd.append(
      "lession_meta_title",
      payload.lession_meta_title || ""
    );

    fd.append(
      "lession_keyword",
      payload.lession_keyword || ""
    );

    fd.append(
      "lession_cat",
      payload.lession_cat || ""
    );

    fd.append(
      "lession_desc",
      payload.lession_desc || ""
    );

    fd.append(
      "lession_duration",
      payload.lession_duration ?? ""
    );

    fd.append(
      "lession_video",
      payload.lession_video || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/lectures/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create Lecture Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Lecture creation failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| UPDATE LECTURE
|--------------------------------------------------------------------------
*/

export async function updateLectureApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append(
      "lession_id",
      payload.lession_id || ""
    );

    fd.append(
      "lession_module",
      payload.lession_module || ""
    );

    fd.append(
      "lession_parent",
      payload.lession_parent || ""
    );

    fd.append(
      "lession_title",
      payload.lession_title || ""
    );

    fd.append(
      "lession_meta_title",
      payload.lession_meta_title || ""
    );

    fd.append(
      "lession_keyword",
      payload.lession_keyword || ""
    );

    fd.append(
      "lession_cat",
      payload.lession_cat || ""
    );

    fd.append(
      "lession_desc",
      payload.lession_desc || ""
    );

    fd.append(
      "lession_duration",
      payload.lession_duration ?? ""
    );

    fd.append(
      "lession_video",
      payload.lession_video || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/lectures/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update Lecture Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Lecture update failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| DELETE LECTURE
|--------------------------------------------------------------------------
*/

export async function deleteLectureApi(lectureId) {
  try {
    const fd = new FormData();

    fd.append(
      "lession_id",
      lectureId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/lectures/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete Lecture Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Lecture deletion failed",
    };
  }
}